/**
 * Onglets du détail d'un entrepôt. Le brief en demandait trois (Résumé, Coûts, Permissions) ; les
 * opérations du contrat en portent davantage : tables exposées, migrations, journal. L'onglet
 * actif vit dans l'URL (`?tab=`). « Définition » (2026-10-23) : nom, description, étiquettes en JSON Patch. Pas d'onglet « Requêter » : la requête SQL est un écran à part
 * (`/$tenant/sql/$warehouseId/query`, `sql-query.ts`).
 */
export const WAREHOUSE_TABS = ['summary', 'tables', 'changes', 'logs', 'costs', 'definition'] as const;
export type WarehouseTab = (typeof WAREHOUSE_TABS)[number];

export const isWarehouseTab = (value: unknown): value is WarehouseTab =>
  typeof value === 'string' && (WAREHOUSE_TABS as readonly string[]).includes(value);
